import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import store from './Redux/store';
import { Provider } from 'react-redux';
import { FaHome } from "react-icons/fa";
import { MdContactPhone } from "react-icons/md";
import { useState } from 'react';
import { links } from './components/Reusable/resuable';
import { Helmet, HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const helmetContext={};

root.render(
  <HelmetProvider context={helmetContext}>
    <Provider store={store}>
      <React.StrictMode>
        <App />
        <SideBar />
      </React.StrictMode>
    </Provider>
  </HelmetProvider>
);

function SideBar() {
  const [side, sidemenu] = useState("hidesb");
  return <div className="quickAccess">
    <div className={side} style={{ position: "relative" }}>
      <div className="quickAccess quickMenu">
        {
          links.map((item) => {
            if (item.submenu !== undefined) {
              return item.submenu.map((e) => e.name === "Brochure" ? <span /> : <a href={e.path} key={e.name}>{e.name}</a>)
            }
            else return <a href={item.path} key={item.name}>{item.name}</a>
          })
        }
      </div>
    </div>
    <FaHome className={side === "hidesb" ? '' : 'active'} size={30} onClick={() => sidemenu(side === "hidesb" ? "showsb" : "hidesb")} />
    <a href="/contactus" style={{ color: "black" }}><MdContactPhone size={30} /></a>
  </div>
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
